<template>
	<Card :bordered="false">
		
		<div class="filter-checkbox-container" v-for="filter in filterList.normalFilter">
			<div style="display: flex;">
				<div class="filter-title">{{filter.filterTitle}}</div>
				<RadioGroup class="checkbox-group" v-model="selectFilterIdList[filter.filterId]" @on-change="handleFilter()">
					<Radio class="checkbox-item" v-for="item in filter.condition" :label="item.id">{{item.title ? item.title : item.name }}</Radio>
				</RadioGroup>
			</div>
			<RadioGroup style='margin-left: 8%;background: #D4D4D4;line-height: 30px;' class="checkbox-group" v-if='filter.filterId == "plateId" && selectFilterIdList.plateId != ""' v-model="selectFilterIdList.businessId" @on-change="handleFilter()">
				<Radio class="checkbox-item" style='margin-bottom: 0;' v-for="item in businessTotalList" :label="item.id">{{item.title ? item.title : item.name }}</Radio>
			</RadioGroup>
		</div>
		<div class="filter-select-container" v-show="filterList.moreFilter.length > 0">
			<div class="filter-title">更多</div>
			<Select class="filter-select" v-model="selectFilterIdList" v-for="filter in filterList.moreFilter" v-if="filter.condition.length>1" :placeholder="filter.filterTitle" @on-change="handleFilter()" filterable multiple>
				<Option v-for="item in filter.condition" :value="item.id">{{ item.title }}</Option>
			</Select>
			<RadioGroup class="checkbox-group" v-model="selectFilterIdList" v-else @on-change="handleFilter()">
				<Radio class="checkbox-item" v-for="item in filter.condition" :label="item.id">{{item.title}}</Radio>
			</RadioGroup>
		</div>
		<div v-show="filterList.inputSearch.length > 0" style="display: flex;width: 92%;">
			<div class="filter-title" style="width: 8%;line-height: 30px;">更多</div>
			<div class="filter-select-container" style="width: max-content;display: flex;margin-right: 20px;" v-for="filter in filterList.inputSearch">
				<div class="filter-title" style="width: 20%;font-weight: normal;font-size: 14px;">{{ filter.filterTitle }}</div>
				<InputNumber 
					class="filter-title-input filter-title-border"
					v-model="selectFilterIdList[filter.minId]" 
					:placeholder="filter.oneTitle" 
					style="width:80px;margin-left:10px;font-size:12px;padding:0 5px;margin-right: 10px;"
					@on-change="handleFilter()"
					:min="inputMinNum"
					></InputNumber>
				<span>-</span>
				<InputNumber 
					class="filter-title-input filter-title-border"
					v-model="selectFilterIdList[filter.maxId]" 
					:placeholder="filter.twoTitle" 
					style="width:80px;margin-left:10px;font-size:12px;padding:0 5px"
					@on-change="handleFilter()"
					:min="inputMinNum"
					></InputNumber>
			</div>
		</div>
		<!-- <div>{{selectFilterIdList}}</div> -->
	</Card>
</template>

<script>
	
import { RadioGroup,Radio,Select,Option,Card, InputNumber } from 'iview'
import { returnPlateListFunc } from '../jc-jsonUtil/publicTotal.js'

export default {
	data() {
		return {
			// "selectFilterIdList": []
			businessTotalList:[],//商圈列表
			inputMinNum: 0, // 输入最小的数
		}
	},
	props:{
		filterList: {
			type: Object,
			default: {
				"normalFilter":[
					{
						"filterTitle":"",
						"condition":[
							{
								"title":"",
								"id":""
							}
						],
					}
				],
				"moreFilter":[
					{
						"filterTitle":"",
						"condition":[
							{
								"title":"",
								"id":""
							}
						],
					}
				],
			}
		},
		selectFilterIdList:{
			type: Object,
			default:{}
		}
	},
	watch: {
	  'selectFilterIdList.plateId': {
	    handler: function() {
	      this.businessTotalList = returnPlateListFunc(this.selectFilterIdList.plateId)
	    },
	      immediate:true
	  },
	},
	mounted() {
		console.log(this.selectFilterIdList,'this.selectFilterIdList.plateId')
		if(this.selectFilterIdList.plateId){
			this.businessTotalList = returnPlateListFunc(this.selectFilterIdList.plateId)
		}
	},
	methods: {
		handleFilter() {
			if(this.selectFilterIdList.plateId){
				this.businessTotalList = returnPlateListFunc(this.selectFilterIdList.plateId)
			}
			console.log(this.selectFilterIdList,'this.selectFilterIdList')
			this.$emit("on-change",this.selectFilterIdList)
		}
		
	},
	
	components:{
		RadioGroup,
		Radio,
		Card,
		Select,
		Option,
		InputNumber
	}
}
</script>

<style scoped="scoped" lang="less">
	@import './index.less';
</style>
